import Redux from 'redux'
import actions, {
  getInvalidCountScheduleListInRangeItems as getInvalidCountScheduleListInRangeItemsAction,
  getScheduleListInRangeItems as getScheduleListInRangeItemsAction,
  resetPlaceScheduleListInRangeItems as resetPlaceScheduleListInRangeItemsAction,
} from './actions'
import { GetScheduleListInRangeItems } from './types'

const getScheduleListInRangeItems = (
  dispatch: Redux.Dispatch,
  request: GetScheduleListInRangeItems,
  locale: string,
) => {
  dispatch(getScheduleListInRangeItemsAction(request, locale))
}

const getPlaceScheduleListInRangeItems = (
  dispatch: Redux.Dispatch,
  request: GetScheduleListInRangeItems,
  locale: string,
) => {
  dispatch(actions.getPlaceScheduleListInRangeItems(request, locale))
}

const resetPlaceScheduleListInRangeItems = (dispatch: Redux.Dispatch) => {
  dispatch(resetPlaceScheduleListInRangeItemsAction())
}

const getInvalidCountScheduleListInRangeItems = (
  dispatch: Redux.Dispatch,
  request: GetScheduleListInRangeItems,
  locale: string,
) => {
  dispatch(getInvalidCountScheduleListInRangeItemsAction(request, locale))
}

const resetInvalidCountScheduleListInRangeItems = (
  dispatch: Redux.Dispatch,
) => {
  dispatch(actions.resetInvalidCountScheduleListInRangeItems())
}

const getMonthlyPlaceScheduleListInRangeItems = (
  dispatch: Redux.Dispatch,
  request: GetScheduleListInRangeItems,
  locale: string,
) => {
  dispatch(actions.getMonthlyPlaceScheduleListInRangeItems(request, locale))
}

export default {
  getScheduleListInRangeItems,
  getPlaceScheduleListInRangeItems,
  resetPlaceScheduleListInRangeItems,
  getInvalidCountScheduleListInRangeItems,
  resetInvalidCountScheduleListInRangeItems,
  getMonthlyPlaceScheduleListInRangeItems,
}
